var React = require('react');

function FacebookIconInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#141614;}")),React.createElement("g",{"id":"Calque_2","data-name":"Calque 2","key":1},React.createElement("g",{"id":"Calque_1-2","data-name":"Calque 1"},React.createElement("path",{"className":"cls-1","d":"M11.82,0A11.83,11.83,0,1,0,23.65,11.82,11.83,11.83,0,0,0,11.82,0Zm2.9,7.75H13.35c-.48,0-.58.19-.58.69V9.65h2l-.19,2.12H12.77V18.1H10.24V11.8H8.93V9.65h1.31V8c0-1.59.85-2.41,2.73-2.41h1.75Z"})))]);
}

FacebookIconInline.defaultProps = {"viewBox":"0 0 23.65 23.65"};

module.exports = FacebookIconInline;

FacebookIconInline.default = FacebookIconInline;
